import {takeEvery, put, fork, all} from 'redux-saga/effects';
import { actions as uiReducerActions } from './uiSlice';

function* onLoadResetNotifications (){
    try {
        yield put(uiReducerActions.clearNotification());
    }
    catch (error) {
        console.log(error);
    }
};

function* onHideNotifications (){
    try {
        yield put(uiReducerActions.hideNotification());
    }
    catch (error) {
        console.log(error);
    }
};

export const actionTypes = {
    ResetNotifications: "[ResetNotifications] Reset Notification UI Slice Action",
    HideNotifications: "[Hide Notification] Hide Notifications UI Slice Action"
};

export const actions = {

    resetNotifications: () => ({ type: actionTypes.ResetNotifications, payload: { undefined }}),
    hideNotifications: () => ({ type: actionTypes.HideNotifications, payload: { undefined }})
};

export function* resetNotifications(){

    yield takeEvery(actionTypes.ResetNotifications, onLoadResetNotifications);
};

export function* hideNotifications(){

    yield takeEvery(actionTypes.HideNotifications, onHideNotifications);
};

const uiSagas = [
    fork(resetNotifications),
    fork(hideNotifications)
];

export function* saga(){
    yield all ([...uiSagas]);
};